export class BatchAction {
    constructor(name, linkedtype, listingName, batchData) {
        this.linkedtype = linkedtype;
        this.listingName = listingName;
        this.name = name;
        this.rowSelection = [];
    }

    setSelectedRows(selection) {
        this.rowSelection = selection;
        return this;
    }

    launch(batchData) {
        var isDoc =
            $.inArray(this.linkedtype, [
                'estimate',
                'invoice',
                'order',
                'delivery',
                'creditnote',
                'proforma',
                'model',
            ]) != -1;
        var isPurDoc =
            $.inArray(this.linkedtype, [
                'purInvoice',
                'purOrder',
                'purDelivery',
                'purCreditNote',
            ]) != -1;

        if (this.linkedtype == 'service') {
            // linkedtype stored in database
            this.linkedtype = 'item';
        }

        switch (this.name) {
            case 'harddelete':
                Third.harddelete(this.rowSelection, this.listingName);
                break;
            case 'rent_createFromGoodsList':
                rentBook.createFroGoodsList(this.rowSelection);
                break;

            case 'massChaseDoc':
                if (this.rowSelection.length > 100) {
                    MyWindow.alert(Loc.g('Vous ne pouvez pas sélectionner plus de 100 éléments.'), {
                        type: 'error',
                    });
                    return;
                }

                DocMassChase.massChaseForm(this.rowSelection);
                break;

            case 'forceDoctsDoctypeSteps':
                DocMassSteps.massStepsForm(this.rowSelection, 'Y');
                break;

            case 'forceDocsSteps':
                DocMassSteps.massStepsForm(this.rowSelection);
                break;

            case 'editItemsCategory':
                ItemsCategory.editItemsCategory(this.rowSelection);
                break;

            case 'tt_markAsBillable':
                TimetrackingEntry.massToggleBillable(this.rowSelection, 'Y');
                break;

            case 'tt_markAsnotBillable':
                TimetrackingEntry.massToggleBillable(this.rowSelection, 'N');
                break;

            case 'addTradeNameToNote':
                Catalogue.massEditTradeNameToNode(this.rowSelection, 'add');
                break;

            case 'deleteTradeNameToNote':
                Catalogue.massEditTradeNameToNode(this.rowSelection, 'delete');
                break;

            case 'switchWarehouse':
                Stock.massswitchStockSerialWh(this.rowSelection);
                break;

            case 'outStock':
                Stock.massStockSerialInOut(this.rowSelection, 'out');
                break;

            case 'inStock':
                Stock.massStockSerialInOut(this.rowSelection, 'in');
                break;

            case 'massResetBooking':
                if (this.rowSelection.length > 500) {
                    MyWindow.alert(Loc.g("Vous ne pouvez pas sélectionner plus de 500 éléments."), { type: "error" });
                    return;
                }
                Stock.massResetBooking(this.rowSelection);
                break;

            case 'resetBooking':
                Stock.resetBooking(this.rowSelection, 'in');
                break;

            case 'removecompta':
                AccountingEntries.massCompta(this.linkedtype, this.rowSelection, 'remove');
                break;

            case 'compta':
                AccountingEntries.massCompta(this.linkedtype, this.rowSelection, 'mark');
                break;

            case 'payment_removecompta':
                AccountingEntries.paymentMassCompta(this.rowSelection, 'remove');
                break;

            case 'payment_compta':
                AccountingEntries.paymentMassCompta(this.rowSelection, 'mark');
                break;

            case 'share':
                if (isDoc) {
                    Sharepoint.massEditForm('doc', this.rowSelection);
                } else if (isPurDoc) {
                    const docIds = this.rowSelection.map(function (value) {
                        return 'pur_' + value.split('_')[1];
                    });
                    Sharepoint.massEditForm('pur', docIds);
                } else {
                    Sharepoint.massEditForm(this.linkedtype, this.rowSelection);
                }
                break;

            case 'updateStateThird':
                Third.updateState(this.rowSelection);
                break;

            case 'updateStatePeople':
                People.updateState(this.rowSelection);
                break;

            case 'deleteThirds':
                Third.deletethirdsGroupAction(this.rowSelection, this.listingName);
                break;

            case 'deletePeople':
                People.deletepeoplesGroupAction(this.rowSelection);
                break;

            case 'updateStateItem':
                Catalogue.updateState(this.rowSelection);
                break;

            case 'inbank':
                Payment.massBankDeposit(this.linkedtype, this.rowSelection);
                break;

            case 'viewInPos':
                Catalogue.switchPosView('Y', this.linkedtype, this.rowSelection);
                break;

            case 'noviewInPos':
                Catalogue.switchPosView('N', this.linkedtype, this.rowSelection);
                break;

            case 'timeTrackignEnabled':
                Catalogue.switchTimetrackingEnabled('Y', this.linkedtype, this.rowSelection);
                break;

            case 'removeTimeTrackignEnabled':
                Catalogue.switchTimetrackingEnabled('N', this.linkedtype, this.rowSelection);
                break;

            case 'editNewItemVat':
                Catalogue.editNewItemVat(this.linkedtype, this.rowSelection);
                break;

            case 'purZip':
            case 'zip':
                var docids = this.rowSelection.map(function (value) {
                    return value.split('_')[1];
                });

                $.ajax({
                    type: 'POST',
                    url: '/documents/export/archive',
                    data: {
                        doctype: this.linkedtype,
                        docids: docids,
                    },
                    success: function (reponse) {
                        MyWindow.alert(
                            Loc.g(
                                "Nous sommes en train de générer le fichier d'export.  Vous recevrez un email avec un lien de téléchargement lorsque le fichier sera prêt",
                            ),
                            { type: 'success' },
                        );
                    },
                    error: function (response) {
                        if (response.status == 400) {
                            MyWindow.alert(response.responseJSON.error.message, { type: 'error' });
                        } else {
                            MyWindow.alert(
                                Loc.g(
                                    'Une erreur est survenue, veuillez ré-essayer ultérieurement.',
                                ),
                                { type: 'error' },
                            );
                        }
                    },
                    dataType: 'json',
                });

                break;

            case 'email_massDelete':
                Email.massDelete();
                break;

            case 'email_massRead':
                Email.massStep(this.linkedtype, this.rowSelection, 'read');
                break;

            case 'email_massUnread':
                Email.massStep(this.linkedtype, this.rowSelection, 'unread');
                break;

            case 'email_BatchDelete':
                EmailBox.batchDelete(this.rowSelection);
                break;
            case 'email_BatchLink':
                EmailBox.batchLink(this.rowSelection);
                break;
            case 'email_BatchRead':
                EmailBox.batchRead(this.rowSelection, true);
                break;
            case 'email_BatchUnread':
                EmailBox.batchRead(this.rowSelection, false);
                break;
            case 'email_BatchStarred':
                EmailBox.batchStarred(this.rowSelection, true);
                break;
            case 'email_BatchUnstarred':
                EmailBox.batchStarred(this.rowSelection, false);
                break;

            case 'opportunity':
                Opportunity.addGroupedOpportunity(this.rowSelection);
                break;

            case 'completeTasks':
                Agenda.completeTaskBatch(this.rowSelection);
                break;

            case 'uncompleteTasks':
                Agenda.uncompleteTaskBatch(this.rowSelection);
                break;

            case 'changeDateTasks':
                Agenda.changeDateTaskBatch(this.rowSelection);
                break;

            case 'statut':
                Support.massUpdateStatus(this.rowSelection);
                break;

            case 'assignTo':
                Support.massUpdateStaff(this.rowSelection);
                break;

            case 'tags':
                Support.massAddTag(this.rowSelection);
                break;

            case 'groupTickets':
                Support.groupTickets(this.rowSelection);
                break;

            case 'purInvoice':
                PurDocInvoices.createFromDeliveries(this.rowSelection);
                break;

            case 'purDelivery':
                PurDocDeliveries.createFromOrders(this.rowSelection);
                break;

            case 'invoice':
                DocInvoices.createFromDeliveries(this.rowSelection);
                break;

            case 'docFusion':
                DocFusion.init(this.rowSelection);
                break;

            case 'exp_refuse':
                expenses.massRefuse(this.rowSelection);
                break;

            case 'exp_accept':
                expenses.massAccept(this.rowSelection);
                break;

            case 'massmailing_mailinglist':
                MailingList.addToOne(this.rowSelection);
                break;

            case 'deleteItem':
                Catalogue.deleteItemGroupAction(this.rowSelection);
                break;

            case 'exportSepa':
                SepaExport.massSepaExport(this.rowSelection);
                break;

            case 'purExportSepa':
                SepaExport.massPurSepaExport(this.rowSelection);
                break;

            case 'recordMassPayments':
                if (this.rowSelection.length > 100) {
                    MyWindow.alert(Loc.g('Vous ne pouvez pas sélectionner plus de 100 éléments.'), {
                        type: 'error',
                    });
                    return;
                }
                const prefix = isDoc ? 'doc' : 'pur';
                MassPayment.massPaymentForm(this.rowSelection, prefix);
                break;

            case 'deleteopportunities':
                Opportunity.deleteOpportunities(this.rowSelection);
                break;

            case 'deletescoringEvent':
                ScoringEvent.batchDelete(this.rowSelection);
                break;

            case 'deletePromotions':
                ItemPromo.MassdeletePromotions(this.rowSelection);
                break;

            case 'addPromotions':
                /* this.rowSelection = $('.groupedActionChecker:checked').map(function () {
                    return $(this).attr('checkerValue2');
                }).get(); */

                if (this.rowSelection === '' || this.rowSelection.length == 0) {
                    MyWindow.alert(Loc.g("vous n'avez sélectionné aucune ligne dans votre liste"), {
                        type: 'error',
                    });
                    return;
                }

                ItemPromo.massAddPromotions(this.rowSelection);

                break;

            case 'stopPromotions':
                ItemPromo.massStopPromotions(this.rowSelection);
                break;

            case 'playPromotions':
                ItemPromo.massPlayPromotions(this.rowSelection);
                break;

            case 'finishPromotions':
                ItemPromo.massFinishPromotions(this.rowSelection);
                break;

            case 'addMassTags':
                if ('people' == this.linkedtype) {
                    Tag.massEditForm('third', this.rowSelection);
                } else {
                    Tag.massEditForm(this.linkedtype, this.rowSelection);
                }
                break;

            case 'assignMassStaff':
                Opportunity.massAssignStaffForm(this.rowSelection);
                break;

            case 'moveOpportunities':
                Opportunity.moveOpportunities(this.rowSelection);
                break;

            case 'updateStatusOpp':
                Opportunity.updateStatusOpp(this.rowSelection);
                break;

            case 'updateDueDateOpp':
                Opportunity.updateDueDateOpp(this.rowSelection);
                break;

            case 'updateSourceOpp':
                Opportunity.updateSourceOpp(this.rowSelection);
                break;

            case 'massEditCustomFields':
                if (this.rowSelection.length > 9999) {
                    MyWindow.alert(
                        Loc.g('Vous ne pouvez pas sélectionner plus de 10000 éléments.'),
                        { type: 'error' },
                    );
                    return;
                }
                CustomFieldForm.massEditForm(this.linkedtype, this.rowSelection, this.listingName);
                break;

            case 'modifyCorpAddress':
                DocFormv2.editAddress('corp', 'doc', this.rowSelection, this.linkedtype);
                break;

            case 'modifyVATMode':
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMassEditVatMode.props =
                    {
                        type: this.listingName,
                        rows: this.rowSelection,
                        emitEditSuccess: 'listing:refresh',
                    };
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMassEditVatMode.display = true;
                break;

            case 'transformProspectToClient':
                Thirds.transformThirds('client', this.rowSelection);
                break;

            case 'transformClientToProspect':
                Thirds.transformThirds('prospect', this.rowSelection);
                break;

            case 'createTask':
                Agenda.createMassTask(this.linkedtype, this.rowSelection);
                break;

            case 'transformThirdType':
                Third.transformThirdType(this.rowSelection, 'corporation');
                break;

            case 'updatePrefsThird':
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMassEditPrefs.props =
                    {
                        type: this.listingName,
                        rows: this.rowSelection,
                        emitEditSuccess: 'listing:refresh',
                    };
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMassEditPrefs.display = true;
                break;

            case 'subscribeCampaignThirds':
                if (this.rowSelection.length > 30000) {
                    MyWindow.alert(
                        Loc.g('Vous ne pouvez pas sélectionner plus de 30000 éléments.'),
                        { type: 'error' },
                    );
                    return;
                }
                Third.subscribeCampaignThirds(this.rowSelection, this.linkedtype, this.listingName);
                break;

            case 'unsubscribeCampaignThirds':
                Third.unsubscribeCampaignThirds(
                    this.rowSelection,
                    this.linkedtype,
                    this.listingName,
                );
                break;

            case 'massTogglePublicLink':
                DocOverview.togglePublicLink(this.linkedtype, this.rowSelection);
                break;

            case 'gocardless_massRetried':
                GoCardless.massRetried(this.rowSelection);
                break;

            case 'gocardless_mandateReminder':
                GoCardless.massMandateReminder(this.rowSelection);
                break;

            case 'gocardless_recordMassDirectdebits':
                GoCardless.recordMassDirectdebits(this.rowSelection);
                break;

            case 'gocardless_massDeleteMandate':
                GoCardless.recordMassDeleteMandate(this.rowSelection);
                break;

            case 'massSetAsConfirmed':
                MassPayment.massSetAsConfirmed(this.rowSelection);
                break;

            case 'dunningMassActivation':
                Dunning.massActivation(this.linkedtype, this.rowSelection);
                break;
            case 'dunningMassDeactivation':
                Dunning.massDeactivation(this.linkedtype, this.rowSelection);
                break;

            case 'companysearch_batchCreate':
                CompanySearch.createMassThird(
                    this.rowSelection,
                    batchData.countryCode,
                    batchData.filters,
                );
                break;

            case 'updateOwner':
                var docIds = this.rowSelection.map(function (value) {
                    return value.split('_')[1];
                });
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.changeOwner.props =
                    { rows: docIds };
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.changeOwner.display = true;
                break;

            case 'updateMode':
                var docIds = this.rowSelection.map(function (value) {
                    return value.split('_')[1];
                });
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.changeGenerationMode.props =
                    {
                        rows: docIds,
                    };
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.changeGenerationMode.display = true;
                break;

            case 'addRecurringTerm':
                var docIds = this.rowSelection.map(function (value) {
                    return value.split('_')[1];
                });
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.addRecurringTerm.props =
                    { rows: docIds };
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.addRecurringTerm.display = true;
                break;

            case 'validateDocument':
                var docIds = this.rowSelection.map(function (value) {
                    return value.split('_')[1];
                });
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.documentValidation.props =
                    {
                        rows: docIds,
                    };
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.documentValidation.display = true;
                break;

            case 'updateBankInfo':
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMassUpdateBankInfo.props = {
                    rows: this.rowSelection,
                    emitEditSuccess: 'listing:refresh',
                };
                window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupMassUpdateBankInfo.display = true;
                break;

            default:
                MyWindow.alert(Loc.g('Vous n’avez selectionné aucune action !'), { type: 'error' });
                break;
        }
    }
}
